import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userSwitchFilled"
const UserSwitchFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.411 18.023 16.345 19.07H21.775V20.686H16.344L17.41 21.732 16.245 22.875 13.19 19.878 16.246 16.88zM10.5 13.125C11.366 13.125 12.148 13.195 12.855 13.32V16.93H14.052L11.047 19.879 11.81 20.625H1.5S1.5 13.125 10.5 13.125M22.94 14.622 19.883 17.62 18.718 16.477 19.784 15.43H14.354V13.814H19.785L18.718 12.768 19.884 11.625zM10.875 1.5C13.567 1.5 15.75 3.683 15.75 6.375S13.567 11.25 10.875 11.25 6 9.067 6 6.375 8.183 1.5 10.875 1.5" />
        </svg>
      }
    </span>
  )
}
export default UserSwitchFilledIcon
